import React from 'react';
import {SubHeading} from '../../components';
import {images, data} from '../../constants'
import {motion} from 'framer-motion'
 
import './Laurels.css';

const AwardCard = ({award: {imgUrl,title, subtitle}}) => (
  <div className="div flex basis[50%] mb-6">
    <img src={imgUrl} alt="" className='w-12 h-12 mr-3 '/>
    <div className="div">
      <p className='text-[#dcca87]'>{title}</p>
      <p className='text-white'>{subtitle}</p>
    </div>
  </div>

)



const Laurels = () => (
  <div className='laurels w-full m-h-screen flex flex-col pt-20 pb-16 sm:mb-16 mb-16 relative ' id='award'>
   <img src={images.bg} alt=""  className='w-full h-[178vh] md:h-[170vh] -z-[2] sm:h-[130vh] absolute top-0 right-0 left-0 bottom-0'/>
  <div className="div w-[80%] m-auto flex flex-col sm:flex-row justify-between items-center">

    <motion.div
    whileInView={{x:[-100,0] , opacity:[0,1]}}
    transition={{duration: 0.8, type: "tween"}}
     className="left basis-[55%] flex flex-col">
      <SubHeading title="Awards and Recognition" />
      <h1 className='text-4xl text-yellow-200 mb-8'>Our laurels</h1>

      <motion.div
       whileInView={{x:[-100,0], opacity:[0,1]}}
    transition={{duration: 0.8, type: "tween"}}
       className="div flex basis[50%] flex-wrap  ">
        {data.awards.map((award) => <AwardCard award={award} key={award.title}  />)}
      </motion.div>

    </motion.div>
    <motion.div
       whileInView={{
                        x: [
                            100, 0
                        ],
                        opacity: [0, 1]
                    }}
                    transition={{
                        duration: 0.8,
                        type: 'tween'
                    }}
     className="right basis-[40%] ">
      <img src={images.laurels} alt="" className='w-[80%] sm:w-full mt-8 mb-24' />
    </motion.div>
  </div>
  </div>
);

export default Laurels;
